export default __webpack_public_path__ + "static/media/logo-ugb-horizontal.aa48e444.png";